import apiClient from "../utils/apiClient";
import { IpWhiteListDto } from "../types/IpWhitelist";
import { UserDto } from "../types/User";

export const getIpWhiteList = async (): Promise<IpWhiteListDto[]> => {
  const response = await apiClient.get<IpWhiteListDto[]>("/Portal/ip-white-list");
  return response.data;
};

// Type-ahead search for the (optional) user dropdown on the whitelist add/edit form.
export const searchWhitelistUsers = async (search: string): Promise<UserDto[]> => {
  const response = await apiClient.get<UserDto[]>("/Portal/ip-white-list/users", {
    params: { search },
  });
  return response.data;
};

export const addIpWhiteList = async (dto: IpWhiteListDto): Promise<number> => {
  const response = await apiClient.post<number>("/Portal/ip-white-list", dto);
  return response.data;
};

export const updateIpWhiteList = async (dto: IpWhiteListDto): Promise<number> => {
  const response = await apiClient.put<number>("/Portal/ip-white-list", dto);
  return response.data;
};

export const deleteIpWhiteList = async (id: number): Promise<number> => {
  const response = await apiClient.delete<number>(`/Portal/ip-white-list/${id}`);
  return response.data;
};
